import PlisseCalcPlisse25 from "../components/calc/plisseltd/CalcPlisse25.svelte";
import PlisseCalcPlisse16 from "../components/calc/plisseltd/CalcPlisse16.svelte";
import PlisseCalcPlugin from "../components/calc/plisse/CalcPlugin.svelte";
import PlisseCalcCommon from "../components/calc/plisseltd/CalcCommon.svelte";
import PlisseCalcO2 from "../components/calc/plisse/CalcO2.svelte";
import PlisseCalcPlisse20 from "../components/calc/plisseltd/CalcPlisse20.svelte";
import PartPrice from "../components/parts/Price.svelte";
import CalcMounting from "../components/calc/CalcMounting.svelte";
import PartMaterials from "../components/parts/Materials.svelte";
import CalcZamer from "../components/calc/CalcZamer.svelte";
import CalcPainting from "../components/calc/CalcPainting.svelte";
import CalcPriceSimple from "../components/parts/PriceSimple.svelte";
import PlisseCalcPlisse25New from "../components/calc/plisseltd/CalcPlisse25New.svelte";
import PlisseCalcPlisse16New from "../components/calc/plisseltd/CalcPlisse16New.svelte";
import CalcFurnituraPlugin from "../components/calc/plisseltd/CalcFurnitura.svelte";
import PartPrice3 from "../components/parts/Price3.svelte";

let list = [];
let logo = null;
let precision = null;

if (APP_TYPE === 'plisse-ltd') {
    logo = 'plisseltd.png';
    precision = 1;

    list.push({
        title: 'Вставная сетка',
        calc: 'Вставная',
        img: '/img/plisse/plugin.jpg',
        description: 'Легкая и быстрая установка подходит для оконного фильтра',
        link: 'вставная',
        component: PlisseCalcPlugin,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,

        ],
        options: {
            color: {
                'Белый(9016RAL)': 'Белый(9016RAL)',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит(7016RAL)': 'Антрацит(7016RAL)',
                'Цветной': 'Цветной',
            },
            uplot: {
                'Шнур фиксирующий': 'Шнур',
            },
            polotno: {
                'Сетка москитная, стандарт': 'Стандарт',
                'Сетка москитная, PPE': 'PPE',
                'Сетка москитная, антикошка белое': 'Антикошка белое',
                'Сетка москитная, антикошка черное': 'Антикошка черное',
                'Сетка москитная, антикошка серая': 'Антикошка серая',
                'Сетка москитная, антикошка серебро': 'Антикошка серебро',
                'Гипоаллергенная': 'Гипоаллергенная',
                'Сетка москитная, АнтиМОШКА': 'АнтиМОШКА',
                'Максимальный обзор': 'Максимальный обзор',
                'Сетка москитная, АнтиПЫЛЬ': 'АнтиПЫЛЬ',
                'Наносетка': 'Наносетка',
                'Нет': 'Нет',
            }



        }
    });

    list.push({
        title: 'Плиссе 16мм NEW',
        calc: 'Плиссе 16мм New',
        img: '/img/plisse/plisse16.jpeg',
        description: 'Сетка плиссе со складками шириной 16мм. Максимальные размеры ширина 3м. и высота 2.7м',
        link: 'плиссе-16new',
        component: PlisseCalcPlisse16New,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
    });

    list.push({
        title: 'Плиссе 25мм NEW',
        calc: 'Плиссе 25мм New',
        img: '/img/plisse/axis-plisse/plisse.jpg,/img/plisse/axis-plisse/plisse2.jpg,/img/plisse/axis-plisse/plisse3.jpg,/img/plisse/axis-plisse/plisse4.jpg,/img/plisse/axis-plisse/plisse5.jpg,/img/plisse/axis-plisse/plisse6.jpg,/img/plisse/axis-plisse/plisse7.jpg,/img/plisse/axis-plisse/plisse8.jpg',
        description: 'Плиссированная сетка со складками шириной 25мм. Профиль: 40-30 мм. Максимальные размеры ширина 6 м. и высота 3м.',
        link: 'плиссе-25new',
        component: PlisseCalcPlisse25New,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,

        ],
    });

    list.push({
        title: 'Рамочная сетка',
        calc: 'Обычная',
        img: '/img/plisse/common.jpg',
        description: 'Рамочная москитная сетка на кронштейнах или крючках',
        link: 'обычная',
        component: PlisseCalcCommon,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,

        ],
        options: {
            color: {
                'Белый(9016RAL)': 'Белый(9016RAL)',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит(7016RAL)': 'Антрацит(7016RAL)',
                'Цветной': 'Цветной',
            },
            polotno: {
                'Сетка москитная, стандарт': 'Стандарт',
                'Сетка москитная, PPE': 'PPE',
                'Сетка москитная, антикошка белое': 'Антикошка белое',
                'Сетка москитная, антикошка черное': 'Антикошка черное',
                'Сетка москитная, антикошка серебро': 'Антикошка серебро',
                'Сетка москитная, антикошка серая': 'Антикошка серая',
                'Гипоаллергенная': 'Гипоаллергенная',
                'Сетка москитная, АнтиМОШКА': 'АнтиМОШКА',
                'Максимальный обзор': 'Максимальный обзор',
                'Наносетка': 'Наносетка',
                'Сетка москитная, АнтиПЫЛЬ': 'АнтиПЫЛЬ',
                'Нет': 'Нет',
            }
        }
    });

    list.push({
        title: 'Плиссе 25мм',
        calc: 'Плиссе 25мм',
        img: '/img/plisse/axis-plisse/plisse.jpg,/img/plisse/axis-plisse/plisse2.jpg,/img/plisse/axis-plisse/plisse3.jpg,/img/plisse/axis-plisse/plisse4.jpg,/img/plisse/axis-plisse/plisse5.jpg,/img/plisse/axis-plisse/plisse6.jpg,/img/plisse/axis-plisse/plisse7.jpg,/img/plisse/axis-plisse/plisse8.jpg',
        description: 'Плиссированная сетка со складками шириной 25мм. Профиль: 40-30 мм. Максимальные размеры ширина 6 м. и высота 3м.',
        link: 'плиссе',
        component: PlisseCalcPlisse25,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,

        ],
        options: {
            porojek: {
                'Нет': 'Рамный(40мм)',
                '225мм': 'Двухсторонний(18мм)',
                '125мм': 'Односторонний(18мм)',
            },

        }
    });

    list.push({
        title: 'Плиссе 20мм',
        calc: 'Плиссе 20мм',
        img: '/img/plisse/plisse16.jpeg',
        description: 'Сетка плиссе со складками шириной 20мм. Максимальные размеры ширина 6м. и высота 3м',
        link: 'плиссе-20',
        component: PlisseCalcPlisse20,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            color: {
                'Белый(9016RAL)': 'Белый(9016RAL)',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит(7016RAL)': 'Антрацит(7016RAL)',
                'Неокрашенный': 'Неокрашенный',
                'Цветной': 'Цветной',
            },
            porojek: {
                'Нет': 'Рамный',
                '1': 'Односторонний',
                '2': 'Двухсторонний',
            },
        }
    });

    list.push({
        title: 'Плиссе 16мм',
        calc: 'Плиссе 16мм',
        img: '/img/plisse/plisse16.jpeg',
        description: 'Сетка плиссе со складками шириной 16мм. Максимальные размеры ширина 3м. и высота 2.7м',
        link: 'плиссе-16',
        component: PlisseCalcPlisse16,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            color: {
                'Белый(9016RAL)': 'Белый(9016RAL)',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит(7016RAL)': 'Антрацит(7016RAL)',
                'Цветной': 'Цветной',
                'Неокрашенный': 'Неокрашенный',
            }
        }
    });

    list.push({
        title: 'Защита нового поколения О2',
        calc: 'Детская',
        img: '/img/plisse/o2.jpeg',
        description: 'Прозрачные решетки (ламели) защитят от выпадения ребенка',
        link: 'защита-о2',
        component: PlisseCalcO2,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            polotno: {
                'Сетка москитная, стандарт': 'Стандарт',
                'Сетка москитная, PPE': 'PPE',
                'Сетка москитная, антикошка белое': 'Антикошка белое',
                'Сетка москитная, антикошка черное': 'Антикошка черное',
                'Сетка москитная, антикошка серебро': 'Антикошка серебро',
                'Сетка москитная, антикошка серая': 'Антикошка серая',
                'Гипоаллергенная': 'Гипоаллергенная',
                'Сетка москитная, АнтиМОШКА': 'АнтиМОШКА',
                'Максимальный обзор': 'Максимальный обзор',
                'Наносетка': 'Наносетка',
                'Сетка москитная, АнтиПЫЛЬ': 'АнтиПЫЛЬ',
                'Нет': 'Нет',
            }
        }
    });

    list.push({
        title: 'Замер',
        calc: 'Замер',
        img: '/img/paint.jpg',
        description: '',
        link: 'замер',
        component: CalcZamer,
        components: [
            CalcPriceSimple,
        ],
    });


    list.push({
        title: 'Комплектующие',
        calc: 'Комплектующие',
        img: '',
        description: 'Продажа комплектующих',
        link: 'sale-komplektuyushih',
        component: CalcFurnituraPlugin,
        components: [
            PartPrice3,
            PartMaterials, // PartMaterialsPercents,
        ],
    });

}

export {list, logo, precision};
